export const objectDefault = {
  // pb_id: 4,

  pb_categoria: "",
  pb_parametro: "",
  pb_usuario: "",
  pb_empresa: "",
  pb_fec_reg: "",
};

export const columns = [
  {
    id: "pb_categoria",
    label: "Categoria",
    minWidth: 25,
    tipo: "string",
    propiedad: "pb_categoria",
  },
  {
    id: "pb_parametro",
    label: "Parametro",
    minWidth: 25,
    tipo: "string",
    propiedad: "pb_parametro",
  },
  {
    id: "pb_usuario",
    label: "User",
    minWidth: 25,
    tipo: "string",
    propiedad: "pb_usuario",
  },
  {
    id: "pb_fec_reg",
    label: "Fec. Reg.",
    minWidth: 25,
    tipo: "string",
    propiedad: "pb_fec_reg",
  },
];
